import { createStore } from 'vuex';

import languages from './modules/languages';
import cart from './modules/cart';
import login from './modules/login';
import layout from './modules/layout';
import course from './modules/course';
import classModule from './modules/classModule';
import location from './modules/location';
import lesson from './modules/lesson';
import exercise from './modules/exercise';
import user from './modules/user';
import currency from './modules/currency';
import progress from './modules/progress';
import validate from './modules/validate';
import cupom from './modules/cupom';
import certificate from './modules/certificate';
import content from './modules/content';
import notification from './modules/notification';

const debug = process.env.NODE_ENV !== 'production';

export default createStore({
    modules: {
        languages,
        exercise,
        location,
        layout,
        course,
        classModule,
        lesson,
        login,
        cart,
        user,
        currency,
        progress,
        validate,
        cupom,
        certificate,
        content,
        notification,
    },
    strict: debug,
});
